import { Component, ViewChild, AfterViewChecked, OnInit } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { AlertService } from './services/alert.service';
import { MiaSplashService } from '@mobileia/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import {registerLocaleData} from '@angular/common'
import localeAr from '@angular/common/locales/es-AR';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {
  @ViewChild('reserveSuccess', { static: false }) private reserveSuccess: SwalComponent;
  @ViewChild('reserveError', { static: false }) private reserveError: SwalComponent;
  @ViewChild('reserveInfo', { static: false }) private reserveInfo: SwalComponent;
  @ViewChild('reserveInfoWithouButton', { static: false }) private reserveInfoWithouButton: SwalComponent;

  isLoading = true;

  constructor(
    protected splashService: MiaSplashService,
    protected alertService: AlertService,
    protected navigator: Router,
    protected route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    // Detectar cuando termina de cargar la primer pagina para ocultar loading
    registerLocaleData(localeAr, 'es-AR');
    this.navigator.events.subscribe(event => {
      if (this.isLoading && event instanceof NavigationEnd) {
        this.processAuth();
        this.splashService.hide();
      }/* else if (event instanceof NavigationStart) {
        this.splashService.show();
      }*/
    });
  }

  processAuth() {
    this.route.queryParams.subscribe(params => {
      const redirect = params.redirect;
      if (redirect !== '/login' && redirect !== '/' && redirect !== '' && redirect !== null
      && redirect !== undefined && redirect !== '%2F' && redirect !== '/login;redirect=%2F') {

          this.navigator.navigateByUrl(redirect);

        /*this.navigator.navigateByUrl(redirect).then(result => {

        });*/
      }
    });
  }

  ngAfterViewChecked(): void {
    this.alertService.setComponent(this);
  }

  showError(title: string, text: string) {
    this.reserveError.title = title;
    this.reserveError.text = text;
    return this.reserveError.fire();
  }

  showSuccess(title: string, text: string) {
    this.reserveSuccess.title = title;
    this.reserveSuccess.text = text;
    this.reserveSuccess.fire();
  }

  showInfo(title: string, text: string) {
    this.reserveInfo.title = title;
    this.reserveInfo.text = text;
    this.reserveInfo.fire();
  }

  showLoading(title: string, text: string) {
    this.reserveInfoWithouButton.title = title;
    this.reserveInfoWithouButton.text = text;
    this.reserveInfoWithouButton.fire();
  }

  hideLoading() {
    this.reserveInfoWithouButton.dismiss();
  }
}
